// FNP-562: token pagination. `limit` and `nextToken` have always been on the
// schema (OrganizationAccountsFilterInput → OrganizationAccountConnection, which
// carries `nextToken`); this query simply never asked for them, so the console
// rendered whatever one unpaginated call returned.
//
// `created` is selected here because it is the DEFAULT SORT KEY. It was not in
// the old selection set, so requesting it is not cosmetic — without it every row
// has an undefined sort key and the default order degrades to insertion order.
export const listOrganizationAccounts = `
   query listOrganizationAccounts($filter:OrganizationAccountsFilterInput, $limit:Int, $nextToken:String) {
       listOrganizationAccounts(filter:$filter, limit:$limit, nextToken:$nextToken) {
           items {
              id
              organizationId
              accountId
              account {
                  id
                  email
              }
              organizationAccountStatus
              created
           }
           nextToken
       }
   }
`;

export const getOrganizationAccount = `
   query getOrganizationAccount($id:ID!) {
       getOrganizationAccount(id:$id) {
         id
         organizationId
         accountId
         account {
             id 
             email
         }
         organizationAccountStatus
         created
         updated
       } 
}`;
